export default __webpack_public_path__ + "static/media/mackin.4e85fe42.png";